import { FloorPlanMemoDiagram } from "~/_legacy/types/analysis";
import { FloorPlanMemoDiagramResponse } from "~/_legacy/types/api";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/rects/`;

export const fetchFloorPlanMemoDiagrams = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
}: {
  branchUid: string;
  branchVersionId?: number;
  floorPlanId: number;
}) => {
  const url = createApiUrl(branchUid, floorPlanId);
  const { data } = await axiosInstance.get<FloorPlanMemoDiagramResponse[]>(url, {
    params: {
      version: branchVersionId,
    },
  });

  const converted: FloorPlanMemoDiagram[] = data.map((memoDiagram) => ({
    id: memoDiagram.id,
    floorPlanId: memoDiagram.floor_plan_id,
    style: {
      fill: memoDiagram.style.fill,
      borderColor: memoDiagram.style.border_color,
      opacity: memoDiagram.style.opacity,
    },
    coordinates: memoDiagram.coordinates,
  }));

  return converted;
};
